import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { coursegroupsApi } from "./coursegroupsApi";

export const useCourseGroupImageSizes = () => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_GROUP_IMAGE_SIZES(),
    queryFn: () => coursegroupsApi.fetchImageSizes(),
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.COURSE_GROUP_IMAGE_SIZES(),
    });
  };

  return {
    invalidate,
    isLoading,
    isFetching,
    imageSizes: data?.data ?? [],
  };
};
